import React, { useState } from 'react';
import styled from 'styled-components';

import ShareModal from '@src/components/common/shareButton/shareModal';
import { ShareIcon } from '@src/components/common/icon';

const Button = styled.button`
	display: flex;
	align-items: center;
`;

const Text = styled.span`
	margin-left: 8px;
	font-size: 14px;
	white-space: nowrap;
`;

interface IShareButton {
	text: string;
	modalTitle: string;
	className?: string;
}

const ShareButton = ({ className, text, modalTitle }: IShareButton): JSX.Element => {
	const [isOpenShareModal, setIsOpenShareModal] = useState(false);

	return (
		<>
			<Button className={className} onClick={() => setIsOpenShareModal(true)}>
				<ShareIcon />
				<Text>{text}</Text>
			</Button>
			{/**
			 * Note:
			 * We use 'window' in <ShareModal />, but 'window' is not defined in SSR.
			 * So hide ShareModal until it is opened to make sure 'window' is used in client side.
			*/}
			{isOpenShareModal && (
				<ShareModal
					isActive={isOpenShareModal}
					headerText={modalTitle}
					handleClose={() => setIsOpenShareModal(false)}
				/>
			)}
		</>
	);
};

export default ShareButton;
